<template>
  <div class="mb-3">
    <v-layout row>
      <v-flex xs1 class="pt-4">
        C
      </v-flex>
      <v-flex xs3 class="pr-3" v-if="isTimeMode() || isDateTimeMode()">
        <time-picker
                v-model="fromTimePicker"
                :interval="30"
                :label="fromLabel"
                placeholder="Время"
                :disabled="!from.enabled"
                @input="onFromTime"
        ></time-picker>
      </v-flex>
      <v-flex xs3 v-if="isDateMode() || isDateTimeMode()">
        <date-picker
                v-model="fromDatePicker"
                :label="isDateMode() ? fromLabel : ''"
                placeholder="Дата"
                :disabled="!from.enabled"
                @input="onFromDate"
        ></date-picker>
      </v-flex>
      <v-flex xs2 class="pt-2 pl-4">
        <v-btn flat fab small @click="resetFrom()">
          <v-icon class="mx-0" style="color: #999;">close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs1 class="pt-4">
        По
      </v-flex>
      <v-flex xs3 class="pr-3" v-if="isTimeMode() || isDateTimeMode()">
        <time-picker
                v-model="toTimePicker"
                :interval="30"
                :label="toLabel"
                placeholder="Время"
                :disabled="!to.enabled"
                @input="onToTime"
        ></time-picker>
      </v-flex>
      <v-flex xs3 v-if="isDateMode() || isDateTimeMode()">
        <date-picker
                v-model="toDatePicker"
                :label="isDateMode() ? toLabel : ''"
                placeholder="Дата"
                :disabled="!to.enabled"
                @input="onToDate"
        ></date-picker>
      </v-flex>
      <v-flex xs2 class="pt-2 pl-4">
        <v-btn flat fab small @click="resetTo()">
          <v-icon class="mx-0" style="color: #999;">close</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>

  import TimePicker from './TimePicker'
  import DatePicker from './DatePicker'
  import { mapGetters } from 'vuex'
  import moment from 'moment'

  /**
   *
   *
   */
  const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm'

  /**
   *
   *
   */
  export default {

    name: 'TimeIntervalPicker',

    components: {
      TimePicker,
      DatePicker
    },

    /**
     * Внешние данные компонента.
     *
     */
    props: {

      // Режим диалогового окна.
      mode: {
        type: String,
        required: true,
        validator: function ( value ) {
          return [ 'date', 'time', 'datetime' ].indexOf( value ) !== -1
        }
      },

      // Включение учета часового пояса.
      isTimeZone: {
        type: Boolean,
        required: false,
        default: false
      },

      // Дата начала интервала.
      fromDate: {
        type: String,
        required: false,
        default: ''
      },

      // Дата окончания интервала.
      toDate: {
        type: String,
        required: false,
        default: ''
      },

      // Название начала интервала.
      fromLabel: {
        type: String,
        required: false,
        default: ''
      },

      // Название окончания интервала.
      toLabel: {
        type: String,
        required: false,
        default: ''
      },
    },

    /**
     * Данные компонента.
     *
     */
    data() {

      return {

        from: {
          name: '',
          description: '',
          required: false,
          value: null,
          time: null,
          enabled: true
        },

        to: {
          name: '',
          description: '',
          required: false,
          value: null,
          time: null,
          enabled: true
        },

        timeZone: null,

        fromTimePicker: null,
        fromDatePicker: null,

        toTimePicker: null,
        toDatePicker: null
      }
    },

    /**
     * После создания компонента.
     *
     */
    created() {

      this.init()
    },

    /**
     * Отслеживание изменений свойств компонента.
     *
     */
    watch: {

      /**
       * Отслеживание значения по умолчанию начала интервала.
       *
       */
      fromDate: {

        handler( value ) {

          if ( value && this.timeZone ) {
            value = this.getLocalDateTime( value )
          }

          this.fromTimePicker = value ? this.getTime( value ) : null
          this.fromDatePicker = value ? this.getDate( value ) : null
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      },

      /**
       * Отслеживание значения по умолчанию окончания интервала.
       *
       */
      toDate: {

        handler( value ) {

          if ( value && this.timeZone ) {
            value = this.getLocalDateTime( value )
          }

          this.toTimePicker = value ? this.getTime( value ) : null
          this.toDatePicker = value ? this.getDate( value ) : null
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      },
    },

    /**
     *
     *
     */
    computed: {
      ...mapGetters( 'app/helpers', [ 'formatDatetime' ] )
    },

    /**
     * Методы компонента.
     *
     */
    methods: {

      /**
       * Преобразование даты в локальную зону.
       *
       */
      getLocalDateTime( dateTime ) {

        if ( !dateTime ) {
          return null
        }

        let moment = this.formatDatetime( dateTime ).date
        this.timeZone = moment.tz()

        return moment.format( DATETIME_FORMAT )
      },

      /**
       * Преобразование даты в UTC зону.
       *
       */
      getUtcDateTime( dateTime ) {
        return moment.tz( dateTime, this.timeZone ).utc().format( DATETIME_FORMAT )
      },

      /**
       *
       *
       */
      getLocalFromDate() {
        return this.getLocalDateTime( this.getFromDate() )
      },

      /**
       *
       *
       */
      getLocalToDate() {
        return this.getLocalDateTime( this.getToDate() )
      },

      /**
       *
       *
       */
      getFromDate() {
        return `${ this.fromDatePicker } ${ this.fromTimePicker }`
      },

      /**
       *
       *
       */
      getToDate() {
        return `${ this.toDatePicker } ${ this.toTimePicker }`
      },

      /**
       *
       *
       */
      init() {

      },

      /**
       * Текущий режим - Время?
       *
       */
      isTimeMode() {
        return this.mode === 'time'
      },

      /**
       * Текущий режим - Дата?
       *
       */
      isDateMode() {
        return this.mode === 'date'
      },

      /**
       * Текущий режим - ДатаВремя?
       *
       */
      isDateTimeMode() {
        return this.mode === 'datetime'
      },

      /**
       *
       *
       */
      onFromTime( time ) {

        let dateTime = time && this.fromDatePicker ? `${ this.fromDatePicker } ${ time }` : null

        dateTime = dateTime && this.isTimeZone ? this.getUtcDateTime( dateTime ) : dateTime
        this.$emit( 'fromDate', dateTime )
      },

      /**
       *
       *
       */
      onFromDate( date ) {

        let dateTime = date && this.fromTimePicker ? `${ date } ${ this.fromTimePicker }` : null

        dateTime = dateTime && this.isTimeZone ? this.getUtcDateTime( dateTime ) : dateTime
        this.$emit( 'fromDate', dateTime )
      },

      /**
       *
       *
       */
      onToTime( time ) {

        let dateTime = time && this.toDatePicker ? `${ this.toDatePicker } ${ time }` : null

        dateTime = dateTime && this.isTimeZone ? this.getUtcDateTime( dateTime ) : dateTime
        this.$emit( 'toDate', dateTime ? this.getUtcDateTime( dateTime ) : dateTime )
      },

      /**
       *
       *
       */
      onToDate( date ) {

        let dateTime = date && this.toTimePicker ? `${ date } ${ this.toTimePicker }` : null

        dateTime = dateTime && this.isTimeZone ? this.getUtcDateTime( dateTime ) : dateTime
        this.$emit( 'toDate', dateTime ? this.getUtcDateTime( dateTime ) : dateTime )
      },

      /**
       *
       *
       */
      getTime( dateTime ) {

        let time = moment( dateTime )

        return time.format( 'HH:mm' )
      },

      /**
       *
       *
       * @param dateTime
       * @returns {string}
       */
      getDate( dateTime ) {

        let date = moment( dateTime )

        return date.format( 'YYYY-MM-DD' )
      },

      /**
       * Удаление начала интервала.
       *
       */
      resetFrom() {
        this.fromDatePicker = null
        this.fromTimePicker = null
      },

      /**
       * Удаление окончания интервала.
       *
       */
      resetTo() {
        this.toDatePicker = null
        this.toTimePicker = null
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/apps/bpm/components/TimeIntervalPicker.vue